import { Tile } from '../../interfaces';
import { getTileSearchKey } from './getTileSearchKey';

export const getTilesSourcesMap = (tiles: Tile[]) => {
    const tilesSourcesMap = new Map();
    tiles.forEach((tile) => tilesSourcesMap.set(getTileSearchKey(tile), tile.key));
    return tilesSourcesMap;
};
